/* eslint-disable react-hooks/exhaustive-deps */
import {memo, useEffect} from 'react'
import {useTranslation} from 'react-i18next'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {contractSelector, setSort, setFilter} from '../../../redux/slices/contractSlices'
import styled from 'styled-components'
import {SelectPageSize} from '../../../components/SelectPageSize/SelectPageSize'
import {StyledButtonGroups} from '../../../components/StyledButtonGroups'

const RightContent = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.25rem;
`

export const ButtonGroupsTableContract = () => {
  const {t} = useTranslation()
  const {sort, filter} = useAppSelector(contractSelector)
  const dispatch = useAppDispatch()

  const handleClick = (event: any) => {
    dispatch(setSort({...sort, checked: event.target.value === 'true' ? true : false}))
  }

  const handlePageSizeChange = (per_page: number | undefined | null) => {
    dispatch(setFilter({...filter, per_page: per_page ?? 5}))
  }

  useEffect(() => {
    handleClick({target: {value: 'false'}})
  }, [])

  return (
    <StyledButtonGroups
      leftContent={
        <SelectPageSize
          initialValue={filter?.per_page ?? 5}
          onChange={(value: any) => handlePageSizeChange(value?.value)}
        />
      }
      rightContent={
        <RightContent>
          <input
            id='unapproved'
            aria-label='Default select example'
            className='me-1'
            type='radio'
            name='approved'
            defaultChecked={true}
            value='false'
            onClick={(event) => handleClick(event)}
          />
          <label className='me-3' htmlFor='unapproved'>
            {t('belumDiperiksa')}
          </label>
          <input
            id='approved'
            aria-label='Default select example'
            className='me-1'
            type='radio'
            name='approved'
            value='true'
            onClick={(event) => handleClick(event)}
          />
          <label className='me-2' htmlFor='approved'>
            {t('sudahDiperiksa')}
          </label>
        </RightContent>
      }
    />
  )
}

export default memo(ButtonGroupsTableContract)
